module.exports = __webpack_public_path__ + "static/media/dagger-common.3d2915aa.png";